import { useTranslation } from '@/lib/i18n';
import {
  Button,
  Dialog,
  DialogClose,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  toast,
} from '@/components/ui';
import { useUserWithdrawalMutation } from '../hooks/useUserWithdrawalMutation';

interface UserWithdrawalConfirmDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  userId: string;
  onSuccess?: () => void;
}

export const UserWithdrawalConfirmDialog = ({
  open,
  onOpenChange,
  userId,
  onSuccess,
}: UserWithdrawalConfirmDialogProps) => {
  const { t } = useTranslation('common');
  const mutation = useUserWithdrawalMutation();

  const handleConfirm = async () => {
    await mutation.mutateAsync({ userId });
    toast.success(t('users.withdrawalDialog.success'));
    onOpenChange(false);
    onSuccess?.();
  };

  return (
    <Dialog open={open} onOpenChange={(o) => !mutation.isPending && onOpenChange(o)}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{t('users.withdrawalDialog.title')}</DialogTitle>
          <DialogDescription>{t('users.withdrawalDialog.desc')}</DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <DialogClose asChild>
            <Button variant="outline" size="sm" disabled={mutation.isPending}>
              {t('users.actions.cancel')}
            </Button>
          </DialogClose>
          <Button
            variant="danger"
            size="sm"
            onClick={() => void handleConfirm()}
            disabled={mutation.isPending}
          >
            {t('users.actions.withdraw')}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
